var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAm3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.2,
    height: 22.2,
    viewBox: "0 0 21.2 22.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "safe",
    transform: "translate(1.012 0.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4744",
    "data-name": "Group 4744",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1603",
    "data-name": "Rectangle 1603",
    width: 20,
    height: 18,
    transform: "translate(-0.412 0.041)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1604",
    "data-name": "Rectangle 1604",
    width: 14,
    height: 13,
    transform: "translate(2.588 3.041)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10.588 7.041)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1605",
    "data-name": "Rectangle 1605",
    width: 4,
    height: 3,
    transform: "translate(13.588 18.041)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1606",
    "data-name": "Rectangle 1606",
    width: 4,
    height: 3,
    transform: "translate(1.588 18.041)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm3);
export default __webpack_public_path__ + "static/media/am3.77a1edc066e8a813ca9ba248030f8998.svg";
export { ForwardRef as ReactComponent };